export const DEPARTMENT_GROUP_NAMES = {
    PLANT_MANAGER: 'Plant/River Group manager',
    PRIMARY_DEPARTMENT: 'Primary Department',
    ASSET_STRATEGY: 'Asset Strategy',
    ASSET_OPERATIONS: 'Energy Asset (Technology)',
    ASSET_MANAGEMENT: 'Energy Asset Management',
    BUSINESS_CONTROLLING: 'Business Controlling',
    NON_REVIEWERS: 'Non-Reviewers'
} as const;
